/**
 * The base/source language. Engineers edit its catalogue directly and Crowdin translates every
 * other locale from it, so its copy only ever changes alongside the code that renders it.
 */
const BASE_LANGUAGE = 'en-JM';
/** i18next's eagerly loaded namespace, the one translation file that is not per-feature. */
export const DEFAULT_NAMESPACE = 'translation';
/** The login screen's namespace, which it renders from before the default namespace has loaded. */
export const LOGIN_SCREEN_NAMESPACE = 'login-screen';
/**
 * The URL i18next fetches a namespace's translation file from.
 *
 * With `baseTranslationsOnly` only the file being fetched changes, never the language i18next is
 * running in: dates, numbers and currency keep formatting for the account's real locale while the
 * copy comes from the base catalogue.
 *
 * @example
 * translationsLoadPath({templatePath: 'locales/{{lng}}-1.2.3.json', namespace: 'headcount', baseTranslationsOnly: false});
 * // 'locales/headcount/{{lng}}-1.2.3.json'
 *
 * @example
 * translationsLoadPath({templatePath: 'locales/{{lng}}-1.2.3.json', namespace: 'translation', baseTranslationsOnly: true});
 * // 'locales/en-JM-1.2.3.json'
 */
export const translationsLoadPath = ({ templatePath, namespace, baseTranslationsOnly, }) => {
    const path = namespace === DEFAULT_NAMESPACE ? templatePath : templatePath.replace('locales/', `locales/${namespace}/`);
    return baseTranslationsOnly ? path.replace('{{lng}}', BASE_LANGUAGE) : path;
};
